import { render, staticRenderFns } from "./hospitalexperts.vue?vue&type=template&id=505e691c"
import script from "./hospitalexperts.vue?vue&type=script&lang=js"
export * from "./hospitalexperts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports